import React from "react";

const ProspectivePlayerContext = React.createContext({});

export default ProspectivePlayerContext;
